import { useEffect } from "react";

const BASE = "ISMAN Admin";

export function useAdminPageTitle(title: string) {
  useEffect(() => {
    document.title = `${title} | ${BASE}`;
  }, [title]);
}